import Base from './Base'

class Formula extends Base {
    static evaluate(body) {
        return this.sendRequest("/formula/evaluate", "POST", {}, body);
    }
}

export default Formula;